import GradientContainer from "../gradient/gradient-container";
import TextGradient from "../gradient/gradient-text";

const TermsSectionHeader = () => {
  return (
    <div className="flex flex-col items-center gap-y-4">
      <TextGradient overrideClassName="text-center">
        <span className="mobile-h3 xs:h4 md:h3">Website Terms and Conditions of Use</span>
      </TextGradient>
      <GradientContainer>
        <div className="h-2 w-36" />
      </GradientContainer>
    </div>
  );
};

export default TermsSectionHeader;
